import React from "react";

const Ecommerce = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h1 style={{ color: "#333", marginBottom: "10px" }}>E-commerce Page</h1>

      <p style={{ fontSize: "16px", color: "#555" }}>
        This is the basic ecommerce page.
      </p>

      <button
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "15px"
        }}
      >
        Click Me
      </button>
    </div>
  );
};

export default Ecommerce;
